import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

import { display, buildEndpointHost, mapValues, getCookie, addTelemetryMetrics } from '@datadog/browser-core';
import { parseJsonPath } from './jsonPathParser';
var REMOTE_CONFIGURATION_VERSION = 'v1';
var SUPPORTED_FIELDS = ['applicationId', 'service', 'env', 'version', 'sessionSampleRate', 'sessionReplaySampleRate', 'defaultPrivacyLevel', 'enablePrivacyForActionName', 'traceSampleRate', 'trackSessionAcrossSubdomains', 'allowedTracingUrls', 'allowedTrackingOrigins'];
export function fetchAndApplyRemoteConfiguration(_x, _x2) {
  return _fetchAndApplyRemoteConfiguration.apply(this, arguments);
}

function _fetchAndApplyRemoteConfiguration() {
  _fetchAndApplyRemoteConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(initConfiguration, supportedContextManagers) {
    var rumInitConfiguration, metrics, fetchResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            metrics = initMetrics();
            _context.next = 3;
            return fetchRemoteConfiguration(initConfiguration);

          case 3:
            fetchResult = _context.sent;

            if (!fetchResult.ok) {
              metrics.increment('fetch', 'failure');
              display.error(fetchResult.error);
            } else {
              metrics.increment('fetch', 'success');
              rumInitConfiguration = applyRemoteConfiguration(initConfiguration, fetchResult.value, supportedContextManagers, metrics);
            } // monitor-until: forever


            addTelemetryMetrics("remote configuration metrics"
            /* TelemetryMetrics.REMOTE_CONFIGURATION_METRIC_NAME */
            , {
              metrics: metrics.get()
            });
            return _context.abrupt("return", rumInitConfiguration);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchAndApplyRemoteConfiguration.apply(this, arguments);
}

export function applyRemoteConfiguration(initConfiguration, rumRemoteConfiguration, supportedContextManagers, metrics) {
  // intents:
  // - explicitly set each supported field to limit risk in case an attacker can create configurations
  // - check the existence in the remote config to avoid clearing a provided init field
  var appliedConfiguration = _objectSpread({}, initConfiguration);

  SUPPORTED_FIELDS.forEach(function (option) {
    if (option in rumRemoteConfiguration) {
      appliedConfiguration[option] = resolveConfigurationProperty(rumRemoteConfiguration[option]);
    }
  });
  Object.keys(supportedContextManagers).forEach(function (context) {
    if (rumRemoteConfiguration[context] !== undefined) {
      resolveContextProperty(supportedContextManagers[context], rumRemoteConfiguration[context]);
    }
  });
  return appliedConfiguration; // share context to access metrics

  function resolveConfigurationProperty(property) {
    if (Array.isArray(property)) {
      return property.map(resolveConfigurationProperty);
    }

    if (isObject(property)) {
      if (isSerializedOption(property)) {
        var type = property.rcSerializedType;

        switch (type) {
          case 'string':
            return property.value;

          case 'regex':
            return resolveRegex(property.value);

          case 'dynamic':
            return resolveDynamicOption(property);

          default:
            display.error("Unsupported remote configuration: \"rcSerializedType\": \"".concat(type, "\""));
            return;
        }
      }

      return mapValues(property, resolveConfigurationProperty);
    }

    return property;
  }

  function resolveContextProperty(contextManager, contextItems) {
    contextItems.forEach(function (_ref) {
      var key = _ref.key,
          value = _ref.value;
      contextManager.setContextProperty(key, resolveConfigurationProperty(value));
    });
  }

  function resolveDynamicOption(property) {
    var strategy = property.strategy;
    var resolvedValue;

    switch (strategy) {
      case 'cookie':
        resolvedValue = resolveCookieValue(property);
        break;

      case 'dom':
        resolvedValue = resolveDomValue(property);
        break;

      case 'js':
        resolvedValue = resolveJsValue(property);
        break;

      default:
        display.error("Unsupported remote configuration: \"strategy\": \"".concat(strategy, "\""));
        return;
    }

    var extractor = property.extractor;

    if (extractor !== undefined && typeof resolvedValue === 'string') {
      return extractValue(extractor, resolvedValue);
    }

    return resolvedValue;
  }

  function resolveCookieValue(_ref2) {
    var name = _ref2.name;
    var value = getCookie(name);
    metrics.increment('cookie', value !== undefined ? 'success' : 'missing');
    return value;
  }

  function resolveDomValue(_ref3) {
    var selector = _ref3.selector,
        attribute = _ref3.attribute;
    var element;

    try {
      element = document.querySelector(selector);
    } catch (_a) {
      display.error("Invalid selector in the remote configuration: '".concat(selector, "'"));
      metrics.increment('dom', 'failure');
      return;
    }

    if (!element) {
      metrics.increment('dom', 'missing');
      return;
    }

    if (isForbidden(element, attribute)) {
      display.error("Forbidden element selected by the remote configuration: '".concat(selector, "'"));
      metrics.increment('dom', 'failure');
      return;
    }

    var domValue = attribute !== undefined ? element.getAttribute(attribute) : element.textContent;

    if (domValue === null) {
      metrics.increment('dom', 'missing');
      return;
    }

    metrics.increment('dom', 'success');
    return domValue;
  }

  function isForbidden(element, attribute) {
    return element.getAttribute('type') === 'password' && attribute === 'value';
  }

  function resolveJsValue(_ref4) {
    var path = _ref4.path;
    var current = window;
    var pathParts = parseJsonPath(path);

    if (pathParts.length === 0) {
      display.error("Invalid JSON path in the remote configuration: '".concat(path, "'"));
      metrics.increment('js', 'failure');
      return;
    }

    var _iterator = _createForOfIteratorHelper(pathParts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var pathPart = _step.value;

        if (!(pathPart in current)) {
          metrics.increment('js', 'missing');
          return;
        }

        try {
          current = current[pathPart];
        } catch (e) {
          display.error("Error accessing: '".concat(path, "'"), e);
          metrics.increment('js', 'failure');
          return;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    metrics.increment('js', 'success');
    return current;
  }
}
export function initMetrics() {
  var metrics = {
    fetch: {}
  };
  return {
    get: function get() {
      return metrics;
    },
    increment: function increment(metricName, type) {
      if (!metrics[metricName]) {
        metrics[metricName] = {};
      }

      if (!metrics[metricName][type]) {
        metrics[metricName][type] = 0;
      }

      metrics[metricName][type] = metrics[metricName][type] + 1;
    }
  };
}

function isObject(property) {
  return _typeof(property) === 'object' && property !== null;
}

function isSerializedOption(value) {
  return 'rcSerializedType' in value;
}

function resolveRegex(pattern) {
  try {
    return new RegExp(pattern);
  } catch (_a) {
    display.error("Invalid regex in the remote configuration: '".concat(pattern, "'"));
  }
}

function extractValue(extractor, candidate) {
  var resolvedExtractor = resolveRegex(extractor.value);

  if (resolvedExtractor === undefined) {
    return;
  }

  var regexResult = resolvedExtractor.exec(candidate);

  if (regexResult === null) {
    return;
  }

  var _regexResult = _slicedToArray(regexResult, 2),
      match = _regexResult[0],
      capture = _regexResult[1];

  return capture ? capture : match;
}

export function fetchRemoteConfiguration(_x3) {
  return _fetchRemoteConfiguration.apply(this, arguments);
}

function _fetchRemoteConfiguration() {
  _fetchRemoteConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(configuration) {
    var response, remoteConfiguration;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(buildEndpoint(configuration));

          case 3:
            response = _context2.sent;
            _context2.next = 9;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            response = undefined;

          case 9:
            if (!(!response || !response.ok)) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", {
              ok: false,
              error: new Error('Error fetching the remote configuration.')
            });

          case 11:
            _context2.next = 13;
            return response.json();

          case 13:
            remoteConfiguration = _context2.sent;

            if (!remoteConfiguration.rum) {
              _context2.next = 16;
              break;
            }

            return _context2.abrupt("return", {
              ok: true,
              value: remoteConfiguration.rum
            });

          case 16:
            return _context2.abrupt("return", {
              ok: false,
              error: new Error('No remote configuration for RUM.')
            });

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _fetchRemoteConfiguration.apply(this, arguments);
}

export function buildEndpoint(configuration) {
  if (configuration.remoteConfigurationProxy) {
    return configuration.remoteConfigurationProxy;
  }

  return "https://sdk-configuration.".concat(buildEndpointHost('rum', configuration), "/").concat(REMOTE_CONFIGURATION_VERSION, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json");
}